export default __webpack_public_path__ + "static/flamingo-6a62fec414d841b70f2ce8b5990c00ea.png";